<template>
    <div class="reset-password">
        <b-row class="justify-content-center">
            <b-col sm="10" class="mb-50">
                <h1 class="text-center">Passwort ändern</h1>
                <h5 class="text-center">Hier kannst du dein neues Passwort eingeben.</h5>
            </b-col>
        </b-row>
        <b-row class="justify-content-center">
            <b-col sm="8" md="5">
                <div class="mandatory-note text-center">
                    <p>* Pflichtfelder bitte ausfüllen</p>
                </div>
                <div class="form-row">
                    <div class="mb-40 col-12 p-0 mt-30 floating-label">
                        <span v-if="valid('email')" class="invalid-feedback">Bitte gültige E-Mail eingeben!</span>
                        <b-form-input type="email" name="email" v-validate="'required|email'" placeholder="E-Mail"
                                      v-model="email"/>
                        <label>E-Mail *</label>
                    </div>
                </div>
                <div class="mb-40 mt-30 floating-label">
                    <b-form-input type="text" placeholder="Reset-Code" name="reset" v-validate="'required'" disabled
                                  v-model="resetCode"/>
                    <label>Reset-Code *</label>
                </div>

                <div class="form-row">
                    <div class="mt-30 col-12 p-0 mb-15 floating-label">
                        <span v-if="valid('password')" class="invalid-feedback">Bitte neues Passwort festlegen!</span>
                        <input type="password"
                               class="form-control"
                               v-validate='{required: true, min:8, regex:/(?=.*[a-z])(?=.*[A-Z])(?=.*[!+=@\-\[\]\\#$;,/":<>{}%^&\*])/ }'

                               name="password"
                               ref="pw1"
                               placeholder="Neues Passwort"
                               v-model="newPassword"/>
                        <label>Neues Passwort *</label>
                        <i class="passwordIcon" :class="[isActive ? 'hide' : 'show']"
                           @click="showPassword($refs.pw1), isActive = !isActive"></i>
                    </div>
                </div>
                <p class="small mb-0">Bitte beachte: Das Passwort muss</p>
                <ul class="password-requirements mb-30">
                    <li :class="{active: eightChars}">- mindestens 8 Zeichen lang sein</li>
                    <li :class="{active: largeChar}">- mindestens einen Großbuchstaben enthalten</li>
                    <li :class="{active: smallChar}">- mindestens einen Kleinbuchstaben enthalten</li>
                    <li :class="{active: specialChar}">- mindestens ein Sonderzeichen enthalten</li>
                </ul>

            </b-col>
        </b-row>

        <b-row class="justify-content-center">
            <b-col sm="6" md="4" class="mt-4 text-center">
                <button class="btn btn-primary"
                        type="button"
                        @click="sendPasswordReset"
                        :disabled="!completed">Absenden</button>
            </b-col>
        </b-row>
    </div>

</template>
<script>

    import {apiNewPassword} from "../utils/api";
    import bcrypt from "bcryptjs";

    export default {
        name: 'passwordResetView',
        data: () => {
            return {
                email: '',
                resetCode: '',
                newPassword: '',
                isActive: '',
            }
        },
        methods: {
            showPassword(x) {
                if (x.type === "password") {
                    x.type = "text";
                } else {
                    x.type = "password";
                }
            },
            valid(name) {
                return this.fields[name] && this.fields[name].touched && !this.fields[name].valid
            },
            sendPasswordReset(){

                let salt = '$2a$10$Y9WDFNqH6NSSjS7e0RcjNe',
                    pwd = bcrypt.hashSync(this.newPassword, salt);

                apiNewPassword({
                    "newEmail": this.email,
                    "resetCode": this.resetCode,
                    "newPasswordhash": pwd
                }).then(response => {

                    if (response.data.code === 0) {
                        this.$toasted.success('Das Passwort wurde erfolgreich zurückgesetzt', {
                            duration: 3000,
                            position: 'bottom-right'
                        });
                        this.$router.push({path: '/login'});
                    } else if (response.data.code === 1) {
                        this.$toasted.error('Passwort inkorrekt', {
                            duration: 3000,
                            position: 'bottom-right'
                        });
                    }
                })
                    .catch(e => {
                        console.log('ERROR: ', e);
                        this.$store.commit('error', e);
                    });
            }
        },
        computed: {

            completed() {
                return Object.keys(this.fields).every(key => this.fields[key].valid)
            },

            eightChars: function () {
                return this.newPassword.length > 7;
            },
            largeChar: function () {
                return (/[A-Z]/.test(this.newPassword));
            },
            smallChar: function () {
                return (/[a-z]/.test(this.newPassword));
            },
            specialChar: function () {
                return (/[~`!#$%\^&*@+=\-\[\]\\';,/{}|\\":<>\?]/g.test(this.newPassword));
            },
            validPassword() {
                return this.eightChars && this.largeChar && this.smallChar && this.specialChar;
            }
        },
        mounted: function () {

            if (this.$route.query.rst) {
                this.resetCode = this.$route.query.rst;
            }

        }
    };
</script>
